export const
    WAYBILL_DATA_UPDATE_NUMBER_VALUE="WAYBILL_DATA_UPDATE_NUMBER_VALUE",
    WAYBILL_DATA_UPDATE_COURIER_VALUE="WAYBILL_DATA_UPDATE_COURIER_VALUE",
    WAYBILL_DATA_UPDATE_CAN_SAVE_VALUE="WAYBILL_DATA_UPDATE_CAN_SAVE_VALUE",
    WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_FAILURE="WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_FAILURE",
    WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_REQUEST="WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_REQUEST",
    WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_SUCCESS="WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_SUCCESS";


// WEBPACK FOOTER //
// ./src/types/WaybillData.js